import { defineStore } from "pinia";
import { ref } from "vue";
import { RumInit } from "@maersk-global/telemetry-web-sdk";
import { isLocalhost } from "@maersk-global/shared-js";
import { grafanaConfig } from "@/utils/common";

export const useTnTRum = defineStore("TnTRum", () => {
  const isLocalhostRef = isLocalhost(window.location.hostname);
  const config = grafanaConfig();

  const faroRum = ref(
    !isLocalhostRef
      ? RumInit({
          app: {
            name: config.name,
            version: "1.0.0",
            environment: config.environment
          },
          useSendBeacon: true,
          apiKey: config.attribute,
          debug: true,
          isolate: true,
          ignoreUrls: [],
          traceLog: true,
          instrumentations: {
            documentload: true,
            xhr: true,
            fetch: true,
            webvitals: true,
            console: true,
            errors: true,
            interactions: {
              eventNames: ["click", "dblclick"]
            }
          }
        })
      : null
  );

  const logRumEvent = (eventName: string, eventType: string, paramName: string, value: string) => {
    return faroRum.value?.api.pushEvent(eventName, {
      type: eventType,
      name: paramName,
      value: value
    });
  };

  return {
    isLocalhostRef,
    faroRum,
    logRumEvent
  };
});
